var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSoytop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 120,
    viewBox: "0 0 132 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.844 0C104.512 0 106.076 0.761564 107.103 2.04327L107.51 2.62375L130.707 40.8055C131.804 42.6099 131.751 44.8631 130.624 46.601L130.209 47.1595L70.1669 118.069C68.132 120.472 64.5355 120.632 62.2922 118.55L61.8331 118.069L1.79156 47.1595C0.427034 45.5482 0.127863 43.3146 0.969702 41.4224L1.29267 40.8055L24.4906 2.62375C25.3566 1.19831 26.8191 0.2586 28.4489 0.0459273L29.1563 0H102.844ZM85.1861 49.091H46.8085L65.9946 96.3928L85.1861 49.091ZM114.274 49.091H96.9651L81.0432 88.3365L114.274 49.091ZM35.0294 49.091H17.7211L50.9459 88.3256L35.0294 49.091ZM42.3873 10.9091H32.2184L15.6469 38.1819H34.5873L42.3873 10.9091ZM78.2594 10.9091H53.7351L45.9352 38.1819H86.0594L78.2594 10.9091ZM99.7762 10.9091H89.6073L97.4073 38.1819H116.348L99.7762 10.9091Z",
    fill: "#5D008B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoytop);
export default __webpack_public_path__ + "static/media/icon_soytop.71e687807191c17da3cad1df4c897f69.svg";
export { ForwardRef as ReactComponent };